import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import Home from './views/Home.vue'
import Gallery from './views/Gallery.vue'
import Wait from './views/Wait.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const galleryRoutes = routes.map(({ url }, index) => ({
  path: `/${url}`,
  name: 'gallery',
  meta: { index },
  component: Gallery
}))

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/wait-for-it',
      name: 'wait',
      component: Wait
    },
    ...galleryRoutes,
    { 
      path: '*', 
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  let now = new Date()
  let ready = new Date('2020-01-31T18:43:00Z')
  if (to.name !== 'wait') {
    if (now < ready) next('/wait-for-it') 
    else next()
  } else {
    if (now >= ready) next('/') 
    else next()
  }
})

router.afterEach((to, from) => setTimeout(() => window.dispatchEvent(new CustomEvent('routeraftereach', { to, from })), 0))

export default router